const VolumeCalculatorType = Object.freeze({
  RATIO: "RATIO",
  MULTIPLIER: "MULTIPLIER",
  FIXED: "FIXED",
});

export default VolumeCalculatorType;
